




























































































































import Vue from 'vue';
import { SparkelloImageUtil, WebDream } from '@/web';
import autosize from 'autosize';
import UnsplashSearch, { UnsplashSearchInterface } from '@/vue-components/util/UnsplashSearch.vue';
import CardHeader from '@/vue-components/util/CardHeader.vue';
import { RemoteImage, SparkelloImage } from 'sparkello-core';
import { MobileUtil } from '@/web/util/MobileUtil';

const mobileUtil = new MobileUtil(window.navigator.userAgent);

export default Vue.component('DreamForm', {
  name: 'DreamForm',
  props: {
    title: String,
    dream: {
      type: Object,
      default: new WebDream('', ''),
    },
    saveCallback: Function,
    cancelCallback: Function,
  },
  components: {
    UnsplashSearch,
    CardHeader,
  },
  data() {
    return {
      editImageMode: false,
      searchTerm: '',
      temporaryImageData: {
        description: '',
        color: '',
        urls: { regular: 'https://backgrounds.sparkello.com/placeholder2.jpg', small: '', thumb:
            '' } ,
        user: { name: '', link:'', 'profile_image':''}
      },
      dreamImageUri: '',
    };
  },
  computed: {
    dreamWhen: {
      get(): string | undefined {
        if (this?.dream) {
          return this?.dream?.when?.get();
        }
        return undefined;
      },
      set(value: string) {
        if (this?.dream) {
          this?.dream?.when?.set(value);
        }
      },
    },
    dreamImportance: {
      get(): number | undefined {
        if (this?.dream) {
          return this?.dream?.importance?.get();
        }
        return undefined;
      },
      set(value: number) {
        if (this?.dream) {
          this?.dream?.importance?.set(value);
        }
      },
    },
  },
  mounted() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));

    SparkelloImageUtil.instance.getRegularImageSource(this.$props.dream.image).then(uri => {
      this.dreamImageUri = uri;
    });
  },
  updated() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  methods: {
    toggleEditImageMode() {
      this.editImageMode = !this.editImageMode || false;

      if (this.editImageMode) {
        this.searchTerm = this.dream.displayName;
        SparkelloImageUtil.instance.getLargeImageSource(this.dream.image).then(uri => {
          this.temporaryImageData.urls.regular = uri;
        })
      }
    },
    save() {
      console.log('Save');
      this.saveCallback(this.dream);
    },
    cancel() {
      console.log('Cancel');
      this.cancelCallback();
      window.scrollTo(0, 0);
    },
    searchStuff() {
      if (this.searchTerm) {
        (this.$refs.unsplash as UnsplashSearchInterface).search(this.searchTerm);
      }
    },
    selectImageCallback(imageData) {
      this.temporaryImageData = imageData;
    },
    acceptImage() {
      if (this.temporaryImageData) {
        (this.$refs.unsplash as UnsplashSearchInterface).download(this.temporaryImageData);
        console.log('Unsplash Imagae Data', this.temporaryImageData);
        // this.dream.image = SparkelloImage.parseRemoteUri(this.temporaryImageData.urls.regular);
        this.dream.image = new SparkelloImage(
          {
            showOverlay: true,
            description: this.temporaryImageData?.description,
            color: this.temporaryImageData?.color,
            authorName: this.temporaryImageData?.user?.name,
            authorProfile: this.temporaryImageData?.user?.link,
            authorProfileImage: this.temporaryImageData?.user?.profile_image,
            largeImage: new RemoteImage({uri: this.temporaryImageData.urls.regular}),
            regularImage: new RemoteImage({uri: this.temporaryImageData.urls?.small}),
            thumbImage: new RemoteImage({uri: this.temporaryImageData.urls?.thumb})
          }
        );
        //Update imageUri displayed in thumbnail box
        SparkelloImageUtil.instance.getRegularImageSource(this.$props.dream.image).then(uri => {
          this.dreamImageUri = uri;
        });
      }
      this.toggleEditImageMode();
      window.scrollTo(0, 0);
    },
    stickyCardClass() {
      if (mobileUtil.isMobile()) {
        return ' sticky-card-mobile ';
      }
      return ' sticky-card ';
    },
  },
});
